import { Box } from "@mui/material";

import Header from "../../components/Header";
//import DataGrid from "devextreme-react/data-grid";

import React, { useEffect, useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

import { useDispatch, useSelector } from "react-redux";
import FeedBackList from "../../components/feedBack/feedBackList";
import { getFeedBack, setFilter } from "../../store/reducers/feedBack";
import FilterBox from "../../components/feedBack/filter";

import { getViolationInspectorTypeReportFun } from "../../store/reducers/report";
import ViolationInspectorTypeReportList from "../../components/reports/violation_inspector_type_report/violation_inspector_type_report_list";

const ViolationInspectorTypeReport = () => {
  const filter = useSelector((state) => state.report.filter);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isCompanyFilter, setIsCompanyFilter] = useState(false);
  const [compName, setCompanyName] = useState("");
  const dispatch = useDispatch();

  return (
    <Box m="20px">
      <Header
        title="АВТОТЭЭВРИЙН ХЯНАЛТЫН УЛСЫН БАЙЦААГЧ / ШИЙТГЭСЭН ЗААЛТ тайлан"
        subtitle="АВТОТЭЭВРИЙН ХЯНАЛТЫН УЛСЫН БАЙЦААГЧ / ШИЙТГЭСЭН ЗААЛТ тайлан жагсаалт"
      />
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 12" },
        }}
      >
        {/* <Box sx={{ gridColumn: "span 3" }}>
          <FilterBox getFilters={setFilters} />
        </Box> */}
        <Box sx={{ gridColumn: "span 12" }}>
          <ViolationInspectorTypeReportList
          //  porkurorReportListData={getViolationInspectorTypeReportData}
          // comptData={compName}
          //  isCompanyFilter={isCompanyFilter}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ViolationInspectorTypeReport;
